angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-blacklist-factory',
        function ($api, $factory) {
            $api.factory.blacklist = $factory;
        },
    ])
    .factory('graph-blacklist-factory', [
        'graph-api-client',
        function (client) {
            function blacklists(entry, id) {
                this.query = function (options) {
                    return client.get([entry, id, 'blacklist'], options);
                };

                this.insert = function (entry_id, options) {
                    return client.post([entry, id, 'blacklist', entry_id], undefined, options);
                };

                this.delete = function (entry_id, options) {
                    return client.delete([entry, id, 'blacklist', entry_id], options);
                };
            }

            /**
             *  @type {String}
             */
            return {
                entry: function (entry, id) {
                    return new blacklists(entry, id);
                },
            };
        },
    ]);
